module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "m-thumbnail",
    style: (!_vm.image ? {} : {
      backgroundImage: ("url(" + _vm.image + ")"),
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "m-thumbnail__inner"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fbcb480"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Thumbnail.vue
// module id = 345
// module chunks = 0